// src/services/adminHealthService.js
import axios from "axios";

// ✅ Use same env key everywhere
const API_BASE = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE,
});


// Attach JWT token if available
api.interceptors.request.use(cfg => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// GET /api/admin/health
export const getWebsiteHealth = () =>
  api.get("admin/health").then(r => r.data);

export { api };
